import { atom } from 'jotai'
import type { RevenueWaterfallGrouping, YearMonth } from './types'

export type TableRowType = 'customer' | 'product' | 'month'

export type TableRow = {
  /** Stable synthetic identifier used for expansion/selection */
  internalId: string
  parentInternalId?: string
  depth: number
  id?: string
  label: string
  type: TableRowType
  customerId?: string
  productId?: string
  bookedTotal: number
  recognized: number
  remaining: number
  monthlyValues: Record<YearMonth, number>
  children: TableRow[]
}

export const resolveRowType = (
  groupType: RevenueWaterfallGrouping
): TableRowType => {
  switch (groupType) {
    case 'CUSTOMER':
      return 'customer'
    case 'PRODUCT':
      return 'product'
    case 'MONTH':
    default:
      return 'month'
  }
}

export const expandedGroupsAtom = atom<Set<string>>(new Set<string>())

export type ExpansionMode = 'all' | 'none' | 'custom'

export const expansionModeAtom = atom<ExpansionMode>('custom')
